export const messages = {
  en: {
    getInStockInfo: {
      queryCondition: 'Query Condition',
      stockStatistics: 'Stock Statistics',
      barCode: 'Barcode',
      prodName: 'Product Name',
      specName: 'Specification',
      stock: 'Stock',
      inStock: 'In Stock',
      price: 'Price',
      unit: 'Unit',
      inStockAmount: 'In Stock Amount',
      returnQuantity: 'Return Quantity',
      returnAmount: 'Return Amount'
    },
    common: {
      query: 'Query',
      reset: 'Reset'
    }
  },
  zh: {
    getInStockInfo: {
      queryCondition: '查询条件',
      stockStatistics: '进货统计',
      barCode: '条形码',
      prodName: '商品名称',
      specName: '规格名称',
      stock: '库存',
      inStock: '入库',
      price: '单价',
      unit: '单位',
      inStockAmount: '入库金额',
      returnQuantity: '退货数量',
      returnAmount: '退货金额'
    },
    common: {
      query: '查询',
      reset: '重置'
    }
  }
}